import { type JSONState } from '#types/form/wizard.ts'

interface RemoveChildrenTreesProps<T> {
	questionTree: JSONState<T>['questionTree']
	formState: JSONState<T>['formState']
	wizardMessages: JSONState<T>['wizardMessages']
	whichChildren: string[]
	currentId: string
	answeredQuestionsStack: JSONState<T>['answeredQuestionsStack']
	resetField: Function
}

export function removeChildrenTrees<T>({
	questionTree,
	formState,
	wizardMessages,
	whichChildren,
	currentId,
	answeredQuestionsStack,
	resetField,
}: RemoveChildrenTreesProps<T>) {
	const shouldBeRemoved = (id: string) => whichChildren.includes(id)

	const shouldFormStateKeyBeRemoved = (key: string) => {
		return whichChildren.some(childId => key.startsWith(childId))
	}

	const newFormState = { ...formState } as any

	Object.keys(formState as any).forEach(key => {
		if (shouldFormStateKeyBeRemoved(key)) {
			delete newFormState[key]
		}
	})

	const isTopParent = !currentId.includes('-')

	let fieldsToReset
	if (isTopParent) {
		fieldsToReset = Object.keys(formState as any).filter(key =>
			key.startsWith(`${currentId}-`),
		)
	} else {
		fieldsToReset = Object.keys(formState as any).filter(key =>
			whichChildren.some(childId => key.startsWith(childId)),
		)
	}

	fieldsToReset.forEach(field => {
		resetField(field)
	})

	const filteredAnsweredQuestionsStack = answeredQuestionsStack.filter(
		stack => !shouldBeRemoved(stack.id),
	)

	const filteredTrees = questionTree.filter(tree => !shouldBeRemoved(tree.id))

	const shouldMessageBeRemoved = (id: string) =>
		whichChildren.includes(id) || id === currentId

	const filteredMessages = wizardMessages!.filter(
		(message: any) =>
			!shouldMessageBeRemoved(message.id) &&
			!shouldMessageBeRemoved(message.backendId),
	)

	return [
		filteredTrees,
		newFormState,
		filteredMessages,
		filteredAnsweredQuestionsStack,
	]
}
